import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
    SyncOutlined,
} from '@ant-design/icons'

class CustomMultiSelect extends Component {
    constructor(props) {
        super(props)

        this.state = {
            openPopup: false,
            selected: []
        }
    }

    componentDidMount() {
        const {selected} = this.props

        if (!!selected && selected.length > 0) {
            this.setState({
                selected: [...selected]
            })
        } else {
            this.setState({ selected: [] })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {selected} = this.props

        if (prevProps.selected !== selected) {
            if (!!selected && selected.length > 0) {
                this.setState({
                    selected: [...selected]
                })
            } else {
                this.setState({ selected: [] })
            }
        }
    }

    _openPopup = () => {
        const {loading} = this.props
        !loading && this.setState({
            openPopup: true
        })
    }

    _closePopup = () => {
        const {selected} = this.props

        this.setState({
            selected: !!selected ? [...selected] : [],
            openPopup: false
        })
    }

    _onSelectAll = () => {
        const {listFilters} = this.props

        this.setState({
            selected: listFilters.map(item => item.value)
        })
    }

    _onClearSelect = () => {
        this.setState({
            selected: []
        })
    }

    _onCheckBoxForDiv = (name) => {
        document.getElementById(name).click()
    }

    _handleChangeCheckbox = (e) => {
        const {checked, name} = e.target
        const {selected} = this.state

        if (checked) {
            this.setState({
                selected: [...selected, name]
            })
        } else {
            this.setState({
                selected: selected.filter(item => item !== name)
            })
        }
    }

    _onFilter = () => {
        const {onChangeFilters, name} = this.props

        if (typeof onChangeFilters === 'function') {
            onChangeFilters(name, this.state.selected)

            this.setState({
                openPopup: false
            })
        }
    }

    _mappingSelected = (selected) => {
        const {listFilters} = this.props

        if (selected.length > 0) {
            return selected.map(item => {
                const result = listFilters.filter(status => status.value === item)

                return result[0].name
            })
        }
    }

    render() {
        const {label, listFilters, placeholder, loading, name} = this.props
        const {openPopup, selected} = this.state

        return (
            <div className='CustomMultiSelect mb-0 form-group' style={{width:'256px'}}>
                <div className={`InputSelect ${loading && 'loading'}`} onClick={this._openPopup}>
                    <span>
                        {selected.length === 0 ? placeholder : this._mappingSelected(selected).join(', ')}
                    </span>
                    {loading && <SyncOutlined spin/>}
                </div>
                <div className={`PopupSelect ${openPopup}`}>
                    <div className="ListItemsSelect">
                        {
                            listFilters.length > 0 && listFilters.map((item, index) =>
                                <div key={index} className='Item'>
                                    <input
                                        id={`${name}_${item.value}`}
                                        type="checkbox"
                                        name={item.value}
                                        checked={selected.includes(item.value)}
                                        onChange={this._handleChangeCheckbox}
                                    />
                                    <label onClick={() => this._onCheckBoxForDiv(`${name}_${item.value}`)}>
                                        {item.name}
                                    </label>
                                </div>
                            )
                        }
                    </div>
                    <div className="Actions">
                        <button onClick={this._onSelectAll} className='LinkAction'>Select All</button>
                        <button
                            disabled={selected.length === 0}
                            className='LinkAction'
                            onClick={this._onClearSelect}
                        >
                            Clear
                        </button>
                        <button onClick={this._onFilter}>Filter</button>
                    </div>
                </div>
                {
                    openPopup && <div className="Background" onClick={this._closePopup}/>
                }
            </div>
        )
    }
}

CustomMultiSelect.defaultProps = {
    loading: false,
}

CustomMultiSelect.propTypes = {
    listFilters: PropTypes.array.isRequired,
    placeholder: PropTypes.string.isRequired,
    onChangeFilters: PropTypes.func.isRequired,
    selected: PropTypes.array,
    name: PropTypes.string,
    loading: PropTypes.bool
}

export default CustomMultiSelect
